import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgxPaginationModule} from 'ngx-pagination';
import {SharedModule} from "../../../shared/shared/shared.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AutoDisqualificationComponent} from "./auto-disqualification.component";
import {ModalRequestAutoDisqualificationAddComponent} from "./modal/modal-request-auto-disqualification-add.component";
import {ModalModule} from "ngx-bootstrap";
import {NgSelectModule} from "@ng-select/ng-select";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    NgSelectModule,
    SharedModule,
    ReactiveFormsModule,
    ModalModule,
  ],
  declarations: [
    AutoDisqualificationComponent,
    ModalRequestAutoDisqualificationAddComponent,
  ]
})
export class AutoDisqualificationModule {
}
